import { Dialog, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

export const ImageDialog = ({ url, size,circle }: { url: string; size?: string,circle?:boolean }) => {
  const [showImageDialog, setShowImageDialog] = React.useState("");

  return (
    <React.Fragment>
      <img
        src={url}
        onClick={() => setShowImageDialog(url)}
        style={{
          objectFit: "cover",
          width: size || "30px",
          height: size || "30px",
          cursor: "pointer",
          borderRadius: circle ? "50%" : "0",
        }}
      />
      <Dialog
        open={!!showImageDialog}
        onClose={() => setShowImageDialog("")}
        sx={{
          "& .MuiDialog-paper": {
            width: "auto",
            height: "auto",
            maxWidth: "90vw",
            maxHeight: "90vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
      ><IconButton
      onClick={() => setShowImageDialog("")}
      sx={{
        position: "absolute",
        top: 8,
        right: 8,
        color: "white",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
      }}
    >
      <CloseIcon color="secondary" />
    </IconButton>

        <img
          src={url}
          style={{
            width: "auto",
            height: "auto",
            maxWidth: "90vw",
            maxHeight: "90vh",
            objectFit: "contain", // Ensures full visibility without breaking aspect ratio
          }}
        />
      </Dialog>
    </React.Fragment>
  );
};
